export const toFixedWithoutZeros = (num:number, precision=2) =>
  `${Number.parseFloat(num.toFixed(precision))}`;